module.exports = __webpack_public_path__ + "static/media/locked.17ee9c7f.png";